import { omit } from "lodash"
import { useCallback, useEffect, useState } from "react"
import { useSearchParams } from "react-router-dom"

import { removeUndefined } from "@tfg/types/schemas/utils"

import { FindCertificatesByOrganizationIdRequestFiltersDto } from "~/gen/api"

export const useSearchParamsFilters = (): [
  FindCertificatesByOrganizationIdRequestFiltersDto,
  React.Dispatch<
    React.SetStateAction<FindCertificatesByOrganizationIdRequestFiltersDto>
  >,
  (key: keyof FindCertificatesByOrganizationIdRequestFiltersDto) => void,
] => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [filters, setFilters] =
    useState<FindCertificatesByOrganizationIdRequestFiltersDto>(
      Object.fromEntries(searchParams.entries())
    )

  useEffect(() => {
    setSearchParams((prev) => ({
      ...prev,
      ...removeUndefined(filters),
    }))
  }, [filters, setSearchParams])

  const unsetFilter = useCallback(
    (key: keyof FindCertificatesByOrganizationIdRequestFiltersDto) => {
      setFilters((prev) => omit(prev, key))
      setSearchParams((prev) => omit(prev, key))
    },
    [setFilters, setSearchParams]
  )

  return [filters, setFilters, unsetFilter]
}
